import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITransportConfigurationService } from './i-transport-configuration.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';

import { IEdiTransporterConfiguration } from '../models/edi-transporter.configuration';

@Injectable({ providedIn: 'root' })
export class EdiTransporterConfigurationService implements ITransportConfigurationService<IEdiTransporterConfiguration> {
  public publicResourceUrl = API_ENDPOINTS.TRANSPORTER_CONFIGURATION;
  public moderatorResourceUrl = API_ENDPOINTS.MODERATOR_TRANSPORTER_CONFIGURATION;

  constructor(protected apiProvider: ApiProviderService) {}

  retrieveConfiguration(transporterId?: number): Observable<HttpResponse<IEdiTransporterConfiguration>> {
    return this.apiProvider.publicGet<IEdiTransporterConfiguration>(this.publicResourceUrl('edi', transporterId), { observe: 'response' });
  }

  updateConfiguration(configuration: IEdiTransporterConfiguration, transporterId?: number): Observable<HttpResponse<IEdiTransporterConfiguration>> {
    return this.apiProvider.configurationPut<IEdiTransporterConfiguration>(this.moderatorResourceUrl('edi', transporterId), configuration);
  }
}
